import { render } from "./MtnOption.vue?vue&type=template&id=e238c70e"
import script from "./MtnOption.vue?vue&type=script&lang=js"
export * from "./MtnOption.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__